import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import classNames from 'classnames/bind';
import React, { useState, useEffect } from 'react';
import { RESPONSIVE } from '../../constants/global.js';
import { useSkeleton } from '../../contexts/SkeletonContext.js';
import styles from './SkeletonCard.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 * @see https://oss.fin.navercorp.com/pages/finance-fe/deFign/v7?path=/story/ui_defign-ui-skeleton-skeletoncard--skeleton-card
 */
function SkeletonCard(_ref) {
  var _ref2, _ref3, _context2;
  var height = _ref.height,
    mobile = _ref.mobile,
    tablet = _ref.tablet,
    desktop = _ref.desktop;
  var _useSkeleton = useSkeleton(),
    isPage = _useSkeleton.isPage;
  var _useState = useState((_ref2 = (_ref3 = mobile !== null && mobile !== void 0 ? mobile : tablet) !== null && _ref3 !== void 0 ? _ref3 : desktop) !== null && _ref2 !== void 0 ? _ref2 : 1),
    _useState2 = _slicedToArray(_useState, 2),
    cardCount = _useState2[0],
    setCardCount = _useState2[1];
  useEffect(function () {
    function handler() {
      var _context;
      var mqDesktop = window.matchMedia("(min-width: ".concat(RESPONSIVE.DESKTOP, "px)"));
      var mqTablet = window.matchMedia(_concatInstanceProperty(_context = "(min-width: ".concat(RESPONSIVE.TABLET, "px) and (max-width: ")).call(_context, RESPONSIVE.DESKTOP - 1, "px"));
      if (mqDesktop.matches) {
        var _ref4, _ref5;
        setCardCount((_ref4 = (_ref5 = desktop !== null && desktop !== void 0 ? desktop : tablet) !== null && _ref5 !== void 0 ? _ref5 : mobile) !== null && _ref4 !== void 0 ? _ref4 : 1);
      } else if (mqTablet.matches) {
        var _ref6, _ref7;
        setCardCount((_ref6 = (_ref7 = tablet !== null && tablet !== void 0 ? tablet : desktop) !== null && _ref7 !== void 0 ? _ref7 : mobile) !== null && _ref6 !== void 0 ? _ref6 : 1);
      } else {
        var _ref8, _ref9;
        setCardCount((_ref8 = (_ref9 = mobile !== null && mobile !== void 0 ? mobile : tablet) !== null && _ref9 !== void 0 ? _ref9 : desktop) !== null && _ref8 !== void 0 ? _ref8 : 1);
      }
    }
    handler();
    window.addEventListener('resize', handler);
    return function () {
      return window.removeEventListener('resize', handler);
    };
  }, [desktop, mobile, tablet]);
  return cardCount > 0 ? ( /*#__PURE__*/React.createElement("div", {
    className: cx('article', {
      'type-page': isPage
    }),
    style: {
      height: "".concat(height, "px")
    }
  }, _mapInstanceProperty(_context2 = _Array$from({
    length: cardCount
  })).call(_context2, function (_, index) {
    return /*#__PURE__*/React.createElement("span", {
      className: cx('skeleton', 'card'),
      key: index
    });
  }))) : null;
}

export { SkeletonCard as default };
